import { apiFetch } from "./client";
import type { Haulier, Page } from "./types";
import type { ListParams } from "./customers";

export interface HaulierPayload {
  haulier_code: string;
  name: string;
  is_active?: boolean;
  phone?: string | null;
  address?: string | null;
  postcode?: string | null;
  account_manager_name?: string | null;
  account_manager_email?: string | null;
  account_manager_phone?: string | null;
}

export async function listHauliers(params: ListParams = {}): Promise<Page<Haulier>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/hauliers${query ? `?${query}` : ""}`);
}

export async function createHaulier(data: HaulierPayload): Promise<Haulier> {
  return apiFetch("/hauliers", { method: "POST", body: JSON.stringify(data) });
}

export async function getHaulier(id: number): Promise<Haulier> {
  return apiFetch(`/hauliers/${id}`);
}

export async function updateHaulier(
  id: number,
  data: Partial<HaulierPayload>,
): Promise<Haulier> {
  return apiFetch(`/hauliers/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteHaulier(id: number): Promise<unknown> {
  return apiFetch(`/hauliers/${id}`, { method: "DELETE" });
}
